// Photos this device put on a record during the session that the server has not yet sent back with
// their audited link: a file it uploaded, or the account's own picture copied onto the care recipient
// or the account's own member. The person looking is the one who put it there.
export class PhotosAwaitingLinks {
    private urls = new Set<string>();

    remember = (url: string): void => {
        this.urls.add(url);
    };

    has = (url: string): boolean => this.urls.has(url);
}
